
class RequestState {
    static Idle = new RequestState('Idle');
    static Loading = new RequestState('Loading');
    static Empty = new RequestState('Empty');
    static Error = (message) => new RequestState('Error', { message });
    static Success = (data) => new RequestState('Success', { data });

    constructor(state, payload = {}) {
        this.state = state
        this.payload = payload
    }

    isLoading() {
        return this.state === 'Loading'
    }

    isError() {
        return this.state === 'Error'
    }

    isEmpty() {
        return this.state === 'Empty'
    }

    isSuccess() {
        return this.state === 'Success'
    }

    getSuccessData() {
        if (this.isSuccess()) {
            return this.payload.data
        }
        throw new Error('Not in Success state')
    }

    getErrorMessage() {
        if (this.isError()) {
            return this.payload.message
        }
        throw new Error('Not in Error state')
    }
}

export default RequestState


// WEBPACK FOOTER //
// ./src/util/RequestState.js